import axios from 'axios'
import constants from '../constants'

const CATEGORY_PATH = constants.urlPrefix + '/api/categories'

const findAllCategories = function () {
    return axios.get(CATEGORY_PATH);
}

const findCategories = function (name) {
    return axios.get(CATEGORY_PATH, {
        params: { name }
    });
}

const createCategory = function (category) {
    return axios.post(CATEGORY_PATH, category);
}

export default {
    findCategories,
    findAllCategories,
    createCategory
}